import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgShow(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M8.99993 12C8.99993 10.3431 10.3431 9 11.9999 9C13.6568 9 14.9999 10.3431 14.9999 12C14.9999 13.6569 13.6568 15 11.9999 15C10.3431 15 8.99993 13.6569 8.99993 12Z", fill: "currentColor" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 5C7.51738 5 3.86058 6.98341 1.09138 10.8319C0.598916 11.5262 0.592277 12.4745 1.09142 13.1681C3.86062 17.0166 7.5174 19 12 19C16.4825 19 20.1393 17.0166 22.9085 13.1681C23.4009 12.4737 23.4077 11.5256 22.9085 10.8318C20.1393 6.98338 16.4825 5 12 5ZM11.9999 7.07501C9.27994 7.07501 7.07495 9.28001 7.07495 12C7.07495 14.72 9.27994 16.925 11.9999 16.925C14.7199 16.925 16.9249 14.72 16.9249 12C16.9249 9.28001 14.7199 7.07501 11.9999 7.07501Z", fill: "currentColor" })));
}
export default SvgShow;
